import React from 'react';
import {Row, Col, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoFinanciera = (infoFinanciera = {}, actual) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={6}>
                {t("messages.aml.year")}
                <Input
                    readOnly
                    value={infoFinanciera.anio}
                    className={actual && infoFinanciera.anio !== actual.anio && "difference"}
                />
                </Col>
                <Col span={6}>
                {t("messages.aml.totalAnnualIncome")}
                <Input
                    readOnly
                    value={infoFinanciera.ingreso}
                    className={actual && infoFinanciera.ingreso !== actual.ingreso && "difference"}
                />
                </Col>
                <Col span={6}>
                {t("messages.aml.totalAnnualExpenses")}
                <Input
                    readOnly
                    value={infoFinanciera.egreso}
                    className={actual && infoFinanciera.egreso !== actual.egreso && "difference"}
                />
                </Col>
                <Col span={6}>
                {t("messages.aml.assetsValue")}
                <Input
                    readOnly
                    value={infoFinanciera.activos}
                    className={actual && infoFinanciera.activos !== actual.activos && "difference"}
                />
                </Col>
                <Col span={6}>
                {t("messages.aml.liabilitiesValue")}
                <Input
                    readOnly
                    value={infoFinanciera.pasivos}
                    className={actual && infoFinanciera.pasivos !== actual.pasivos && "difference"}
                />
                </Col>
                <Col span={6}>
                {t("messages.aml.profitLoss")}
                <Input
                    readOnly
                    value={infoFinanciera.utilidad}
                    className={actual && infoFinanciera.utilidad !== actual.utilidad && "difference"}
                />
                </Col>
                <Col span={6}>
                {t("messages.aml.numberOfEmployees")}
                <Input
                    readOnly
                    value={infoFinanciera.nroEmpleados}
                    className={actual && infoFinanciera.nroEmpleados !== actual.nroEmpleados && "difference"}
                />
                </Col>
            </Row>
        </div>
    );
};

export default InfoFinanciera;